// extracted by mini-css-extract-plugin
module.exports = {"bodyDefault":"DesktopTable_bodyDefault__e4qF3","tableHeaderRow":"DesktopTable_tableHeaderRow__Wq__s","tableHeader":"DesktopTable_tableHeader__Iqn28"};